import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { startMenuMusic, stopMenuMusic, isMenuMuted, setMenuMuted } from "@/lib/menuAudio";

export const MenuMusic = () => {
  const [muted, setMuted] = useState(isMenuMuted());
  useEffect(() => {
    const go = () => { startMenuMusic(); off(); };
    const off = () => { window.removeEventListener("pointerdown", go); window.removeEventListener("keydown", go); };
    window.addEventListener("pointerdown", go); window.addEventListener("keydown", go);
    if (navigator.userActivation?.hasBeenActive) startMenuMusic();
    return () => { off(); stopMenuMusic(); };
  }, []);
  const toggle = (e) => { e.stopPropagation(); setMenuMuted(!muted); setMuted(!muted); startMenuMusic(); };
  return (
    <button type="button" onPointerDown={(e) => e.stopPropagation()} onClick={toggle}
      className="fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-black/70 border-2 border-[#2E3440] hover:border-[#64748B] px-3 py-2 pixel-text text-lg text-[#9CA3AF] hover:text-[#F3F4F6] transition-colors"
      aria-label={muted ? "Unmute music" : "Mute music"} data-testid="menu-music-toggle">
      {muted ? <VolumeX size={16} /> : <Volume2 size={16} />} {muted ? "MUSIC OFF" : "MUSIC ON"}
    </button>
  );
};
